module.exports = __webpack_public_path__ + "static/media/people13.97853fac.jpeg";